import * as React from 'react';
import { memo } from 'react';

const PremiumAmenities = () => (
  <svg
    width="27"
    height="34"
    viewBox="0 0 27 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.802 19.2909V16.8663C23.802 15.4654 22.8353 15.2948 22.352 15.3846C21.308 15.6001 21.1437 16.3724 21.192 16.7316"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <rect
      x="1.06303"
      y="19.4546"
      width="24.8652"
      height="8.17933"
      stroke="white"
      strokeWidth="0.981519"
    />
    <path
      d="M7.11621 19.6182V27.4703"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <path
      d="M19.5479 19.6182V27.4703"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <circle cx="5.31596" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="5.31596" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="5.31596" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="21.021" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="21.021" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="21.021" cy="21.4176" r="0.49076" fill="white" />
    <circle cx="11.5328" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="11.5328" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="11.5328" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="13.4956" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="13.4956" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="13.4956" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="15.4585" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="15.4585" cy="21.0905" r="0.49076" fill="white" />
    <circle cx="15.4585" cy="21.0905" r="0.49076" fill="white" />
    <path
      d="M7.11621 22.5627H19.2216"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <path
      d="M9.0791 18.6366L12.3508 18.6366"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <path
      d="M14.3135 18.6366L17.5852 18.6366"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
    <path
      d="M13.9705 8.37597V8.60925L14.1514 8.75654L17.7493 11.6861V14.2198H7.93412V11.6861L11.5321 8.75654L11.713 8.60925V8.37597V6.69486H13.9705V8.37597Z"
      stroke="white"
      strokeWidth="0.981519"
    />
    <path
      d="M8.09766 11.766H17.9129"
      stroke="white"
      strokeWidth="0.981519"
      strokeLinecap="round"
    />
  </svg>
);

const Memo = memo(PremiumAmenities);
export default Memo;
